import React from "react";
import styles from "./styles.module.scss";

const Collateral = () => {
    return (
        <div className={styles.collateral}>
            <div>Collateral Component</div>
        </div>
    );
};

export default Collateral;
